<template>
    <span class="mb-1">
        <badge v-if="active" type="success">
            Active
        </badge>
        <badge v-else type="default">
            Inactive
        </badge>
    </span>
</template>
<script>
import { Badge } from '@/components/UIComponents'
export default {
    components: {
        Badge
    },
    props: {
        active: {
            type: Boolean
        }
    }
}
</script>

<style lang="scss" scoped>
.p-badge {
    margin-right: 0.25rem;
}
</style>
